import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import ListDetailView from 'Components/UI/ListDetailView';
import { withStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useBackgroundColor from 'Hooks/useBackgroundColor';
import { navigateToPage } from 'Views/Page/Content/Templates';
import Detail from './Detail';
import DetailHeader from './DetailHeader';
import ListHeader from './ListHeader';
import ListItem from './ListItem';

const styles = () => ({
  root: {},
});

const Files = ({
  className,
  classes,
}) => {
  const { householdResource } = useSimpleHousehold();
  const linkUrl = householdResource?.relationship(fr.relationships.files.name)?.link('related')?.url();
  const theme = useTheme();
  const bgColor = theme.palette.facet.lightGray;
  useBackgroundColor(bgColor);

  if (!householdResource) {
    return null;
  }

  if (!linkUrl) {
    navigateToPage(householdResource.relationship(fr.relationships.managedAccountDocumentsPage.name)?.link('related')?.url(), false);
  }

  return (
    <ListDetailView
      className={classNames(classes.root, className)}
      linkUrl={linkUrl}
      queryValName="fileSelfLink"
      getSelfLink={(resource) => {
        return resource.relationship(fr.relationships.file.name).link('related').url();
      }}
      DetailViewComponent={Detail}
      DetailViewHeaderComponent={DetailHeader}
      ListViewListItemComponent={ListItem}
      ListViewHeaderComponent={ListHeader}
      ListViewListProps={{
        explicitlyWhiteBackground: true,
        showSkeletonAvatar: true,
        test: 'pwa-files-page',
      }}
    />
  );
};

Files.defaultProps = {
  className: '',
};

Files.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Files);
